import { simpleParamsSerializer } from '../../../utils/url-helper.js';

export enum BeaconType {
    LOAD_TIMEOUT = 'load_timeout',
    AUCTION_TIMEOUT = 'auction_timeout',
    AUCTION_COMPLETE = 'auction_complete',
}

export type BeaconPayload = {
    source: string;
    type: BeaconType;
}

export const triggerBeacon = (payload: BeaconPayload) => {
    try {
        window.navigator.sendBeacon('https://ih.adscale.de/event', simpleParamsSerializer(payload));
    } catch (e) {
        // ignore
    }
}
